/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Address } from './address';


export interface RouteSection { 
    origin: Address;
    destination: Address;
    startTime: string;
    endTime: string;
    transportMode: RouteSectionTransportModeEnum;
    durationInSeconds: number;
    lengthInMeters: number;
    polyline: string;
}
export enum RouteSectionTransportModeEnum {
    car = 'car',
    bike = 'bike',
    walk = 'walk',
    scooter = 'scooter',
    transit = 'transit',
    carpool = 'carpool',
    internalShuttle = 'internalShuttle'
};



